module.exports = __webpack_public_path__ + "img/save-code.f7b402c9.png";